
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"d":"M5.948 7.5 8.216 2c.505 0 .99.198 1.347.55.357.35.558.828.558 1.325L9.996 6.5h3.594a1.288 1.288 0 0 1 .973.43 1.244 1.244 0 0 1 .298 1.007l-.752 5.5c-.046.299-.2.57-.433.765-.233.196-.53.301-.837.298H3.77a1.28 1.28 0 0 1-.898-.366 1.24 1.24 0 0 1-.372-.884v-4.5c0-.332.134-.65.372-.884A1.28 1.28 0 0 1 3.77 7.5h2.178Zm0 0H5.5v7","stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    